<template>
  <div class="page error">
    <div>
      <h1 class="h2">404 – Seite nicht gefunden</h1>
      <p>Die von Ihnen aufgerufene Seite konnte nicht geladen werden. Bitte kehren Sie zur <router-link to="/" exact>Startseite</router-link> zurück.</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Error',
  props: {

  },
  data () {
    return {

    }
  },
  watch: {

  },
  mounted() {
    if (this.$route.params.id != "error") {
      this.$router.push('/error');
    }
    document.title = "Fehler | Schabbell 360";
  },
  created() {

  },
  beforeDestroy() {

  },
  computed: {

  },
  methods: {

  },
}
</script>
